/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ price: NonNullable<unknown> }} Notifications_Message_Body_NowInputs */

const he_notifications_message_body_now = /** @type {(inputs: Notifications_Message_Body_NowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`עכשיו ${i?.price}`)
};

const en_notifications_message_body_now = /** @type {(inputs: Notifications_Message_Body_NowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`now ${i?.price}`)
};

/**
* | output |
* | --- |
* | "now {price}" |
*
* @param {Notifications_Message_Body_NowInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_message_body_now = /** @type {((inputs: Notifications_Message_Body_NowInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Message_Body_NowInputs, { locale?: "he" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_notifications_message_body_now(inputs)
	return en_notifications_message_body_now(inputs)
});